fx.ns("shared.renderers", class FrontCoverRenderer extends fx.Component {
    
	constructor(data, book)
	{
        super(data);
        this.book = book;
    }

    create()
    {
        let thumb, width, height;
        switch(this.book.shape_option)
        {
            case "square":
                thumb = this.data.thumb_front_square;
                width = 210;
                height = 210;
                break;
            case "landscape":
                thumb = this.data.thumb_front_landscape;
                width = 210;
                height = 147;
                break;
            case "portrait":
                thumb = this.data.thumb_front_portrait;
                width = 168;
                height = 240;
                break;
        }

        this.thumbnail = new fx.components.Image({className : "cover-thumb", data : thumb});
		this.usedIcon = new fx.components.Image({data : fx.assets.used2, className : "usedIcon"});
		this.usedIcon.visibleAtStart = false;
		
		this.addChild( this.thumbnail, { width : width, height : height});
        this.addChild(this.usedIcon, {top:5, right:5, width:32, height:32});

        this.attr("data-behaviour", "apply-layout");
        this.attr("data-class", "Theme");
        this.attr("data-id", this.data.id);
        this.addClass("draggable");
    }

    onDataUpdated(action)
    {
        if (action.impacts("selected") || action.type == "init")
        {
            if (this.data.selected)
                this.usedIcon.show();
            else
                this.usedIcon.hide();
        }
    }
});
